import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SnoozeModalService {
  constructor(private http: HttpClient) {}

  snoozeCPModal(email) {
    const url = `${environment.backend_server_url_account}/${email}/snooze-modal`;
    return this.http.post(url, {});
  }
}
